 <template>
    <a-spin :spinning="loading" tip="Carregando...">
        <a-table
            :columns="columns"
            :data-source="rows"
            :rowKey="row => row.id"
            :pagination="{ pageSize: 10 }"
            :rowSelection="rowSelection"
            size="small"
            bordered
        />
        <div class="footer">
            <a-space>
                <a-button @click="$emit('cancel')">Fechar</a-button>
                <a-button type="primary" :disabled="!internalSelectedId" @click="emitSave">Salvar</a-button>
            </a-space>
        </div>
    </a-spin>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'

const props = defineProps({
    selectedId: { type: [Number, String, null], default: null }, // pré-seleção opcional
    endpoint:   { type: String, default: '/api/configurations/faqs' } // se quiser customizar
})
const emit = defineEmits(['save', 'cancel'])

const loading = ref(false)
const rows = ref([])

const selectedRowKeys = ref(
    props.selectedId ? [Number(props.selectedId)] : []
)
const internalSelectedId = computed(() =>
    selectedRowKeys.value.length ? selectedRowKeys.value[0] : null
)

const columns = [
    { title: 'ID',     dataIndex: 'id',          key: 'id',          width: 80,  sorter: (a,b)=>a.id-b.id },
    { title: 'Ordem',  dataIndex: 'order',       key: 'order',       width: 90,  sorter: (a,b)=>a.order-b.order },
    { title: 'Nome',   dataIndex: 'name',        key: 'name',        width: 220, sorter: (a,b)=>String(a.name).localeCompare(String(b.name)) },
    { title: 'Descrição', dataIndex: 'description', key: 'description' }
]

const rowSelection = computed(() => ({
    type: 'radio',
    selectedRowKeys: selectedRowKeys.value,
    onChange: (keys) => { selectedRowKeys.value = keys.map(Number) },
}))

async function load() {
    try {
        loading.value = true
        const { data } = await window.axios.get(props.endpoint)
        rows.value = data?.data ?? data ?? []
    } finally {
        loading.value = false
    }
}

function emitSave () {
    if (!internalSelectedId.value) return
    emit('save', internalSelectedId.value)
}

onMounted(load)

// atualiza seleção se prop mudar
watch(() => props.selectedId, (val) => {
    selectedRowKeys.value = val ? [Number(val)] : []
})
</script>

<style scoped>
.footer {
    display:flex;
    justify-content:flex-end;
    margin-top: 12px;
}
</style>
